var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegetablesBroccoli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9069 18.3655C19.2677 15.2668 16.7351 12.7323 13.6376 11.0908",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5054 11.0922C9.73339 16.0708 6.55472 19.9588 1.78939 23.5788C1.56145 23.7534 1.37344 23.9746 1.23795 24.2277C1.10247 24.4808 1.02265 24.76 1.00384 25.0464C0.98503 25.3329 1.02766 25.6201 1.12888 25.8888C1.2301 26.1574 1.38756 26.4013 1.59073 26.6042L5.39606 30.4095C5.59899 30.6126 5.84299 30.77 6.11169 30.8711C6.3804 30.9722 6.66762 31.0147 6.95409 30.9957C7.24057 30.9768 7.51969 30.8969 7.77275 30.7613C8.02581 30.6257 8.24696 30.4375 8.42139 30.2095C12.0414 25.4455 15.9294 22.2655 20.9067 21.4948",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4666 23.4882C15.7942 24.8913 16.6123 26.1312 17.7733 26.9846C18.9343 27.8379 20.3619 28.2485 21.7989 28.1423C23.2359 28.0362 24.5877 27.4203 25.6107 26.4056C26.6337 25.3909 27.2607 24.0442 27.3786 22.6082C28.0677 22.311 28.695 21.8873 29.2279 21.3588C29.9309 20.6619 30.4517 19.8028 30.7445 18.8572C31.0374 17.9116 31.0933 16.9085 30.9073 15.9362C30.7213 14.9639 30.2992 14.0523 29.678 13.2815C29.0569 12.5108 28.2558 11.9045 27.3452 11.5162C27.4887 10.5827 27.4103 9.6286 27.1165 8.73107C26.8226 7.83354 26.3215 7.01782 25.6538 6.34995C24.9861 5.68209 24.1704 5.18085 23.273 4.88682C22.3755 4.59278 21.4214 4.51423 20.4879 4.6575C20.0254 3.57115 19.2543 2.64432 18.2703 1.99176C17.2863 1.3392 16.1325 0.989576 14.9518 0.98617C13.7711 0.982764 12.6153 1.32573 11.6275 1.9726C10.6397 2.61947 9.86339 3.54184 9.39458 4.6255C7.96589 4.7532 6.62903 5.3843 5.62248 6.40622C4.61593 7.42814 4.00516 8.77441 3.89913 10.2049C3.7931 11.6353 4.1987 13.0569 5.04358 14.2161C5.88846 15.3752 7.11766 16.1966 8.51191 16.5335",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.08 8.86591C14.9948 9.55283 14.6771 10.1899 14.1798 10.6714C13.6825 11.1529 13.0355 11.4498 12.3462 11.5129C11.6568 11.576 10.9667 11.4014 10.3903 11.0181C9.81386 10.6348 9.38588 10.066 9.17737 9.4059",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4987 15.6416L16.308 12.8323",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3585 18.5001L19.1652 15.6921",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1347 16.9205C22.4477 17.0055 21.8105 17.323 21.3288 17.8202C20.8471 18.3174 20.55 18.9644 20.4868 19.6538C20.4236 20.3431 20.5981 21.0334 20.9812 21.6099C21.3644 22.1864 21.9333 22.6145 22.5934 22.8231",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetablesBroccoli);
export default __webpack_public_path__ + "static/media/VegetablesBroccoli.0645924e35323f94e8ec2e6b39099239.svg";
export { ForwardRef as ReactComponent };